import { createTheme } from '@mui/material/styles';
import { defaultTheme } from './base';

const baseTheme = defaultTheme();

const gtrPalette = {
    primary: {
        main: '#000000',
        light: '#25282B',
        dark: '#000000',
        contrastText: '#FFFFFF',
    },
    secondary: {
        main: '#284C35',
        light: '#284C35',
        dark: '#1a3324',
        contrastText: '#FFFFFF',
    },
    text: {
        primary: '#25282B',
        secondary: '#000000',
        disabled: 'rgba(255,255,255,0.5)',
    },
    background: {
        default: '#FFFFFF',
        paper: '#FFFFFF',
    },
    divider: '#D9D9D9',
    buttons_bg: {
        primary: '#000000',
        primary_hover: '#25282B',
        secondary: 'transparent',
        info: 'transparent',
        primary_dark: '#000000',
    },
    buttons_text: {
        primary: '#FFFFFF',
        secondary: '#000000',
        secondary_hover: '#25282B',
        info: '#000000',
        info_hover: '#25282B',
    },
    additional: {
        accent: '#284C35',
        overlay: 'rgba(0,0,0,0.5)',
        overlayLight: 'rgba(0,0,0,0.15)',
    },
};

export const gtrTheme = createTheme(baseTheme, {
    palette: gtrPalette,
    typography: {
        fontFamily: ['Archivo', 'Archivo Narrow', 'Nunito', 'sans-serif'].join(','),
        h1: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '32px',
            letterSpacing: '0.2px',
            color: '#25282B',
        },
        h2: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '20px',
            letterSpacing: '0.2px',
            color: '#25282B',
        },
        h3: {
            fontFamily: 'Archivo',
            fontWeight: 300,
            fontSize: '24px',
            lineHeight: '1.167em',
            letterSpacing: '0.83%',
            color: '#25282B',
        },
        h4: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '24px',
            lineHeight: '1.5em',
            letterSpacing: '0.83%',
            color: '#000000',
        },
        h5: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '1.5em',
            letterSpacing: '0.2px',
            color: '#25282B',
        },
        h6: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.2px',
            color: '#25282B',
        },
        body1: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '16px',
            lineHeight: '1.25em',
            letterSpacing: '1.25%',
            color: '#25282B',
        },
        body2: {
            fontFamily: 'Archivo',
            fontWeight: 300,
            fontSize: '16px',
            lineHeight: '1.25em',
            letterSpacing: '1.25%',
            color: '#25282B',
        },
        subtitle1: {
            fontFamily: 'Archivo Narrow',
            fontWeight: 400,
            fontSize: '14px',
            lineHeight: '1.347em',
            letterSpacing: '1.43%',
            color: '#25282B',
        },
        subtitle2: {
            fontFamily: 'Archivo',
            fontWeight: 600,
            fontSize: '14px',
            lineHeight: '22px',
            letterSpacing: '0.1px',
            color: '#000000',
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    fontFamily: 'Archivo, Archivo Narrow, Nunito, sans-serif',
                    color: '#25282B',
                    backgroundColor: '#FFFFFF',
                    'p, div': {
                        color: '#25282B',
                    },
                },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    fontFamily: 'Archivo',
                },
            },
        },
        MuiDivider: {
            styleOverrides: {
                root: {
                    borderColor: '#D9D9D9',
                },
            },
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    backgroundColor: '#FFFFFF',
                    color: '#000000',
                    boxShadow: 'none',
                    borderBottom: '1px solid #D9D9D9',
                },
            },
        },
    },
});
